import { Group, Menu, Stack, Title, Tooltip, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useAuthentication, useAvailableApps } from '@scoring/logic';
import { IconLayoutGrid, IconMoon, IconPower, IconSun, IconUser } from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router';
import { ApiImageAvatar } from '../images';
import { ActiveUserModal } from './ActiveUserModal';

interface ActiveUserProps {
    showName?: boolean;
}

const ActiveUser = ({ showName }: ActiveUserProps) => {
    const { user, logout } = useAuthentication();
    const [activeUserModalOpened, { open: openActiveUserModal, close: closeActiveUserModal }] = useDisclosure();
    const { setColorScheme } = useMantineColorScheme();
    const computedColorScheme = useComputedColorScheme('light', { getInitialValueInEffect: true });
    const navigate = useNavigate();
    const onLandingPage = useLocation().pathname === '/';
    const canSwitchApp = useAvailableApps().apps.length > 1 && !onLandingPage;

    const userFullName = user?.firstName + ' ' + user?.lastName;

    return (
        <Tooltip label={userFullName}>
            <div>
                <ActiveUserModal opened={activeUserModalOpened} onClose={closeActiveUserModal} />
                <Menu position="bottom">
                    <Menu.Target>
                        <Group gap={8} style={{ cursor: 'pointer' }}>
                            <ApiImageAvatar
                                variant="filled"
                                color="blue"
                                size={'sm'}
                                name={userFullName}
                                imageId={user?.profilePictureImageId}
                                m={0}
                            />
                            {showName && (
                                <Stack gap={0}>
                                    <Title size={11} fw={500}>
                                        {user?.email}
                                    </Title>
                                </Stack>
                            )}
                        </Group>
                    </Menu.Target>
                    <Menu.Dropdown>
                        <Menu.Item
                            leftSection={
                                computedColorScheme === 'light' ? <IconMoon size={14} /> : <IconSun size={14} />
                            }
                            onClick={() => setColorScheme(computedColorScheme === 'light' ? 'dark' : 'light')}
                        >
                            {computedColorScheme === 'light' ? 'Dark' : 'Light'} Mode
                        </Menu.Item>

                        <Menu.Divider />
                        {canSwitchApp && (
                            <Menu.Item
                                leftSection={<IconLayoutGrid size={14} />}
                                onClick={() => navigate('/', { state: { pick: true } })}
                            >
                                Switch App
                            </Menu.Item>
                        )}
                        <Menu.Item leftSection={<IconUser size={14} />} onClick={() => openActiveUserModal()}>
                            Manage
                        </Menu.Item>
                        <Menu.Item leftSection={<IconPower size={14} />} onClick={() => logout()}>
                            Logout
                        </Menu.Item>
                    </Menu.Dropdown>
                </Menu>
            </div>
        </Tooltip>
    );
};

export default ActiveUser;
